import type * as Actions from './actions';
import { FuelCardActionTypes as Types } from './fuelCardActionTypes';

import type { DateRange, FuelCardVehicle, FuelTransaction, FuelTransactionBodyContent, UUID } from '@cobliteam/common-types';

import type { FuelCardMatching } from '@cobliteam/api-lib';

export const downloadTransactionsReportRequest = (period: DateRange): Actions.DownloadTransactionsReportRequest => ({
  type: Types.DOWNLOAD_TRANSACTIONS_REPORT_REQUEST,
  payload: period,
});

export const downloadTransactionsReportEnd = (): Actions.DownloadTransactionsReportEnd => ({
  type: Types.DOWNLOAD_TRANSACTIONS_REPORT_END,
});

export const loadFuelTransactionsRequest = (period: DateRange): Actions.LoadFuelTransactionsRequest => ({
  type: Types.LOAD_FUEL_TRANSACTIONS_REQUEST,
  payload: period,
});

export const loadFuelTransactionsSucceeded = (transactions: FuelTransaction[]): Actions.LoadFuelTransactionsSucceeded => ({
  type: Types.LOAD_FUEL_TRANSACTIONS_SUCCEEDED,
  payload: transactions,
});

export const loadFuelTransactionsFailed = (): Actions.LoadFuelTransactionsFailed => ({
  type: Types.LOAD_FUEL_TRANSACTIONS_FAILED,
});

export const saveFuelTransactionsRequest = (body: FuelTransactionBodyContent) => ({
  type: Types.SAVE_FUEL_TRANSACTIONS_REQUEST,
  payload: body,
});

export const saveFuelTransactionsSucceeded = (fuelTransaction: FuelTransactionBodyContent) => ({
  type: Types.SAVE_FUEL_TRANSACTIONS_SUCCEEDED,
  payload: fuelTransaction,
});

export const saveFuelTransactionsFailed = () => ({
  type: Types.SAVE_FUEL_TRANSACTIONS_FAILED,
});

export const loadFuelVehiclesRequest = (): Actions.LoadFuelVehiclesRequest => ({
  type: Types.LOAD_FUEL_VEHICLES_REQUEST,
});

export const loadFuelVehiclesSucceeded = (vehicles: FuelCardVehicle[]): Actions.LoadFuelVehiclesSucceeded => ({
  type: Types.LOAD_FUEL_VEHICLES_SUCCEEDED,
  payload: vehicles,
});

export const loadFuelVehiclesFailed = (): Actions.LoadFuelVehiclesFailed => ({
  type: Types.LOAD_FUEL_VEHICLES_FAILED,
});

export const updateFuelVehiclesRequest = (vehicles: FuelCardVehicle[]): Actions.UpdateFuelVehiclesRequest => ({
  type: Types.UPDATE_FUEL_VEHICLES_REQUEST,
  payload: vehicles,
});

export const updateFuelVehiclesEnd = (): Actions.UpdateFuelVehiclesEnd => ({
  type: Types.UPDATE_FUEL_VEHICLES_END,
});

export const loadFuelCardMatchingsRequest = (fuelCardStatus: string): Actions.LoadFuelCardMatchingsRequest => ({
  type: Types.LOAD_FUEL_CARD_MATCHINGS_REQUEST,
  payload: { fuelCardStatus },
});

export const loadFuelCardMatchingsSucceeded = (fuelCardMatchings: FuelCardMatching[]): Actions.LoadFuelCardMatchingsSucceeded => ({
  type: Types.LOAD_FUEL_CARD_MATCHINGS_SUCCEEDED,
  payload: fuelCardMatchings,
});

export const loadFuelCardMatchingsFailed = (): Actions.LoadFuelCardMatchingsFailed => ({
  type: Types.LOAD_FUEL_CARD_MATCHINGS_FAILED,
});

export const saveFuelCardMatchingRequest = (id: UUID, licensePlate?: string): Actions.SaveFuelCardMatchingRequest => ({
  type: Types.SAVE_FUEL_CARD_MATCHING_REQUEST,
  payload: {
    id,
    licensePlate,
  },
});

export const saveFuelCardMatchingSucceeded = (id: UUID, licensePlate?: string): Actions.SaveFuelCardMatchingSucceeded => ({
  type: Types.SAVE_FUEL_CARD_MATCHING_SUCCEEDED,
  payload: {
    id,
    licensePlate,
  },
});

export const saveFuelCardMatchingFailed = (): Actions.SaveFuelCardMatchingFailed => ({
  type: Types.SAVE_FUEL_CARD_MATCHING_FAILED,
});
